import React, {useState, useMemo, useEffect} from "react";
import useAddHubZip from "../hooks/use-add-hub-zip";
import {Spinner} from "react-bootstrap";
import {swalError, swalSuccess} from "../../../../Components/sweetAlert";
import useGetHubZip from "../hooks/use-get-hub-zip";
import useDeleteHubZip from "../hooks/use-delete-hub-zip";
import * as Icon from "react-bootstrap-icons";

const HubUserZipEdit = ({HubId}) => {
    const [zipcode, setZipcode] = useState('');
    const [district, setDistrict] = useState('');
    const [sub_district, setSubDistrict] = useState('');
    const [province, setProvince] = useState('');
    const [currentZip, setCurrentZip] = useState(null);
    const {add, update,errorMessage,loading} = useAddHubZip(() => {
        if(currentZip){
            swalSuccess({
                text: 'รหัสไปรษณีย์ได้รับการอัปเดตเรียบร้อยแล้ว',
            });
            setCurrentZip(null);
        }
        else {
            swalSuccess({
                text: 'เพิ่มรหัสไปรษณีย์สำเร็จแล้ว',
            });
        }
        setZipcode('');
        setDistrict('');
        setSubDistrict('');
        setProvince('');
        fetch(HubId);
    });
    const {fetch, loading: getLoading, errorMessage: getErrorMessage, data } = useGetHubZip();

    const {remove, loading: removeLoading, errorMessage: removeErrorMessage} = useDeleteHubZip(() => {
        swalSuccess({
            text: 'ลบรหัสไปรษณีย์เรียบร้อยแล้ว',
        });
        fetch(HubId);
    });

    const isInvalidZipCode = useMemo(() => {
        return zipcode.length!==5 || !new RegExp('^[0-9]*$').test(zipcode);
    }, [zipcode]);

    useEffect(() => {
            fetch(HubId);
    },[HubId]);

    useEffect(() => {
        if(errorMessage){
            swalError({
                text: 'รหัสไปรษณีย์มีอยู่แล้วสำหรับฮับนี้'
            });
        }
        if(removeErrorMessage){
            swalError({
                text: 'An error occured'
            });
        }
    }, [errorMessage,removeErrorMessage]);

    const isLoading = loading || getLoading || removeLoading;
    return (
        <div className="w-full">
            {!isLoading &&
                <>
                    <form onSubmit={() => {
                        currentZip ? update(currentZip.id,zipcode,district,sub_district,province) : add(HubId,zipcode,district,sub_district,province);
                    }} className="w-full">
                        <h3>{currentZip ? `อัปเดตรหัสไปรษณีย์ (${currentZip.zip})` : 'เพิ่มรหัสไปรษณีย์'}</h3>
                        <div className="row mb-3">
                            <div className="col-3 d-flex flex-column">
                                <label htmlFor="zip">เพิ่มรหัสไปรษณีย์</label>
                                <input name="zip" value={zipcode} onChange={(e) => setZipcode(e.target.value)}/>
                            </div>
                            <div className="col-3 d-flex flex-column">
                                <label htmlFor="zip">DISTRICT</label>
                                <input name="zip" value={district} onChange={(e) => setDistrict(e.target.value)}/>
                            </div>
                            <div className="col-3 d-flex flex-column">
                                <label htmlFor="zip">SUB-DISTRICT</label>
                                <input name="zip" value={sub_district} onChange={(e) => setSubDistrict(e.target.value)}/>
                            </div>
                            <div className="col-3 d-flex flex-column">
                                <label htmlFor="zip">PROVINCE</label>
                                <input name="zip" value={province} onChange={(e) => setProvince(e.target.value)}/>
                            </div>
                            <div className="col-2 d-flex align-items-end m-1">
                                <button disabled={isInvalidZipCode} className="btn btn-primary">{currentZip ? 'อัปเดต' : 'เพิ่ม'}</button>
                            </div>
                            {isInvalidZipCode && <p className="col-12 error-invalid-feedback">รหัสไปรษณีย์ควรเป็นตัวเลข 5 ตัว</p>}
                        </div>
                    </form>
                    {data && <div className="w-full">
                        <table className="table table-bordered">
                            <thead className="table-blue">
                                <th>ซิป</th>
                                <th>District</th>
                                <th>Sub-District</th>
                                <th>Province</th>
                                <th>&nbsp;</th>
                            </thead>
                            <tbody>
                                {data.map(({id,zip,district,sub_district,province}) => (<tr>
                                    <td key={id}>{zip}</td>
                                    <td key={id+district+'district'}>{district}</td>
                                    <td key={id+sub_district+'sub_district'}>{sub_district}</td>
                                    <td key={id+province+'province'}>{province}</td>
                                    <td>
                                        <button onClick={() => {
                                            setCurrentZip({
                                                id,
                                                zip
                                            });
                                            setZipcode(zip);
                                        }} className="btn btn-primary mr-1">
                                            <Icon.PencilSquare style={{ color: "#ffff" }} />
                                        </button>
                                        <button onClick={(e) => {
                                            void remove(id);
                                        }} className="btn btn-danger">
                                            <Icon.TrashFill />
                                        </button>
                                    </td>
                                </tr>))}
                            </tbody>
                        </table>
                    </div>}
                </>
            }
            {isLoading &&
                <div className="spinner-global-content">
                    <Spinner variant="success" animation="border" />
                </div>
            }
        </div>
    );
};

export default HubUserZipEdit;